export const DEFAULT_FORM = {
  title: '',
  description: '',
};

export const TITLE_MAX_LENGTH = 100;

export const DESCRIPTION_MAX_LENGTH = 1000;
